import config from 'constants/config'
import { useAppSelector } from 'hooks/reduxHooks'

// TODO: Re-enable the Maldives banner in ~1 week (disabled 4 Jan 2026)
const MALDIVES_BANNER_END_DATE_MS = new Date('2026-01-04T00:00:00+11:00').getTime()

const MALDIVES_BANNER_BRANDS: Array<App.BrandName> = [
  'luxuryescapes',
  'leagenthub',
  'leagenthub_cvfr',
]

/**
 * Hook to determine if the Maldives Charter banner should be shown.
 * Shows for AU users until campaign end date.
 */
export function useShowMaldivesBanner(): boolean {
  const currentRegionCode = useAppSelector(state => state.geo.currentRegionCode)
  const isBrandSupported = MALDIVES_BANNER_BRANDS.includes(config.BRAND)
  const isRegionSupported = currentRegionCode === 'AU' || (config.agentHub.isEnabled && currentRegionCode === 'NZ')
  return isBrandSupported && isRegionSupported && Date.now() < MALDIVES_BANNER_END_DATE_MS
}
